import Drawer from "../../../../drawer/Drawer";
import ManageCategory from "../ManageCategory";

const ManageCategoryDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl3"}
      size={"xl3"}
      title={data?._id ? "Update Category" : "Add Category"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageCategory getResponse={getResponse} close={close} data={data} />
      </div>
    </Drawer>
  );
};

export default ManageCategoryDrawer;
